import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import * as React from 'react';
import { createContext, ReactElement, useContext, useState } from 'react';

type DSD = React.Dispatch<React.SetStateAction<DialogProps>>;   // DSD -> Dispatch SetStateAction DialogProps

type DialogProps = {
    variant?: 'error',
    title: string;
    content?: string | ReactElement;
    open: boolean;
    yesBtnTitle: string;
    noBtnTitle: string;
    yesCallback: (close: () => void) => void | null;
    noCallback: (close: () => void) => void | null;
};

// Definizione del contesto
const UpdateDialogContextWithError = createContext<DSD | null>(null);

// Hook di utility per accedere al value del contesto
const useDialogContextWithError: () => DSD = () => useContext(UpdateDialogContextWithError);

/* HOC di utility, per la gestione di una dialog generale */
const DialogContextWithErrorProvider = ({ children }) => {

    const [dialog, setDialog] = useState<DialogProps>({
        title: '',
        yesBtnTitle: '',
        noBtnTitle: '',
        open: false,
        yesCallback: null,
        noCallback: null
    });

    const closeDialog = React.useCallback(() => {

        setDialog({
            ...dialog,
            open: false
        });
    }, [dialog]);

    return (
        <UpdateDialogContextWithError.Provider value={setDialog}>
            {children}
            <Dialog
                sx={{
                    '& .MuiDialogTitle-root': {
                        color: '#005075',
                        borderBottom: dialog?.variant === 'error' ? '2px solid #D82829' : '2px solid #0090D1',
                        backgroundColor: 'white'
                    },
                }}
                open={dialog.open}
                fullWidth={true}
                maxWidth="xs"
            >
                <DialogTitle dangerouslySetInnerHTML={{ __html: dialog.title }} />
                {dialog.content && typeof dialog.content === 'string' ? (
                    <DialogContent>
                        <DialogContentText dangerouslySetInnerHTML={{ __html: dialog.content }} />
                    </DialogContent>
                ) : (
                    <DialogContent>
                        <DialogContentText>{dialog.content}</DialogContentText>
                    </DialogContent>
                )}
                <DialogActions>
                    {dialog?.variant === 'error' ? (
                        <React.Fragment>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={() => { dialog.yesCallback(closeDialog); }}
                            >
                                {dialog.yesBtnTitle}
                            </Button>
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={() => { dialog.noCallback(closeDialog); }}
                            >
                                {dialog.noBtnTitle}
                            </Button>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={() => { dialog.noCallback(closeDialog); }}
                            >
                                {dialog.noBtnTitle}
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => { dialog.yesCallback(closeDialog); }}
                            >
                                {dialog.yesBtnTitle}
                            </Button>
                        </React.Fragment>
                    )}
                </DialogActions>
            </Dialog>
        </UpdateDialogContextWithError.Provider>
    );
};

export default DialogContextWithErrorProvider;

export {
    useDialogContextWithError
};
